import { DomainStatus, ServiceStatus } from "Store/downtime/interfaces";
import { StatusMessage, StatusType } from "./interfaces";

import { isDefined } from "Utils/functions";
import { isIterable } from "Utils/generalUtils";

const getDownStatus = ({
  isDown,
  isDownTitle: title,
  isDownMessage: message,
}: ServiceStatus): StatusMessage | undefined =>
  isDown ? { title, message, statusType: StatusType.DOWNTIME } : undefined;

const getUnstableStatus = ({
  isUnstable,
  isUnstableTitle: title,
  isUnstableMessage: message,
}: ServiceStatus): StatusMessage | undefined =>
  isUnstable
    ? { title, message, statusType: StatusType.INSTABILITY }
    : undefined;

export const getPrioritizedStatus = (
  domain: DomainStatus,
): StatusMessage | undefined => {
  if (isIterable(domain.services)) {
    const [status] = [...domain.services]
      .sort(
        (service, compareService) =>
          Number(service.priority) - Number(compareService.priority),
      )
      .map((service) => getDownStatus(service) ?? getUnstableStatus(service))
      .filter(isDefined);
    return status;
  }
  return undefined;
};
